// `wp` (wp-dom-ready etc.) isn't enqueued on every page this file runs on (e.g. my-account/view-order) -
// relying on `wp.domReady` there throws a ReferenceError that halts the rest of this bundled script,
// silently breaking every domReady block below it. Use a dependency-free equivalent instead.
const domReady = ( callback ) => {
	if ( document.readyState !== 'loading' ) {
		callback();
	} else {
		document.addEventListener( 'DOMContentLoaded', callback );
	}
};

domReady( () => {
	const account_btn_elem = document.querySelector( '.header-account-button' );
	if ( account_btn_elem ) {
		account_btn_elem.ariaLabel  = "Account";
	}
} );

domReady( () => {
	const checkoutNode = document.querySelector( '.wp-block-woocommerce-checkout' );

	if ( checkoutNode ) {
		const observer = new MutationObserver( () => {
			const step_description = document.querySelector( '.wc-block-checkout__payment-method .wc-block-components-radio-control .wc-block-components-radio-control-accordion-content:not(:has(.on-file-payment_description)) > :first-child' );
			if ( step_description ) {
				observer.disconnect();
				step_description.classList.add("on-file-payment_description");
				step_description.parentElement.insertAdjacentElement( 'beforeend', step_description );
				observer.observe( checkoutNode, { childList: true, subtree: true } );
			}
		} );
		observer.observe( checkoutNode, { childList: true, subtree: true } );
	}
} );


domReady( () => {
	document.querySelectorAll( '.birnn-invoice-actions' ).forEach( ( actions_elem ) => {
		const ajax_url = actions_elem.dataset.ajaxUrl;
		const status_elem = actions_elem.querySelector( '.birnn-invoice-status' );

		const print_btn = actions_elem.querySelector( '[data-invoice-action="print"]' );
		if ( print_btn ) {
			print_btn.addEventListener( 'click', () => {
				const details_section = actions_elem.closest( '.woocommerce-order-details' );
				if ( ! details_section ) {
					return;
				}
				const customer_section = details_section.nextElementSibling?.classList.contains( 'woocommerce-customer-details' )
					? details_section.nextElementSibling
					: null;

				const print_node = document.createElement( 'div' );
				print_node.id = 'birnn-print-invoice';
				print_node.appendChild( details_section.cloneNode( true ) );
				if ( customer_section ) {
					print_node.appendChild( customer_section.cloneNode( true ) );
				}
				document.body.appendChild( print_node );
				document.body.classList.add( 'birnn-printing-invoice' );

				window.onafterprint = () => {
					document.body.classList.remove( 'birnn-printing-invoice' );
					print_node.remove();
					window.onafterprint = null;
				};
				window.print();
			} );
		}

		const email_btn = actions_elem.querySelector( '[data-invoice-action="email"]' );
		if ( email_btn ) {
			email_btn.addEventListener( 'click', () => {
				email_btn.disabled = true;
				status_elem.textContent = '';

				fetch( ajax_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: new URLSearchParams( {
						action: 'birnn_email_invoice',
						order_id: email_btn.dataset.orderId,
						nonce: email_btn.dataset.nonce,
					} ),
				} )
					.then( ( response ) => response.json() )
					.then( ( result ) => {
						status_elem.textContent = result?.data?.message ?? '';
					} )
					.catch( () => {
						status_elem.textContent = 'Something went wrong. Please try again.';
					} )
					.finally( () => {
						email_btn.disabled = false;
					} );
			} );
		}
	} );
} );

domReady( () => {
	const payment_choice = document.querySelector( '.woocommerce .woocommerce-order table.widefat.striped td p' );
	if ( payment_choice ) {
		var payment_method_xpath = "//td[text()='On File Payment']";
		var payment_method = document.evaluate(payment_method_xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

		if ( payment_method ) {
			payment_method.insertAdjacentElement( 'beforeend', payment_choice );
		}
	}
} );
